import { reportStepsAPI } from '../../services/api';
import { useReportState } from './useReportState';
import { getTaskSelection } from '../../utils/taskIdValidator';
import i18n from '../../i18n';

export const useFileUpload = () => {
  const {
    state,
    setTaskId,
    setCurrentStep,
    setIsLoading,
    setError
  } = useReportState();

  const uploadExcelFile = async (file: File) => {
    // Get current taskId from localStorage
    const { taskId: currentTaskId } = getTaskSelection();
    
    if (!currentTaskId) {
      setError(i18n.t('create:processing.error_task_not_init'));
      return;
    }
    
    try {
      setIsLoading(true);
      setError(null);
      
      // Update taskId from localStorage if needed
      if (currentTaskId !== state.taskId) {
        console.log('uploadExcelFile - обновляем taskId из localStorage:', currentTaskId);
        setTaskId(currentTaskId);
      }
      
      await reportStepsAPI.uploadExcelFile(currentTaskId, file);
      
      setCurrentStep('analytics');
    } catch (err: any) {
      setError(err.response?.data?.detail || i18n.t('common:error'));
      setCurrentStep('error');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    uploadExcelFile,
    isLoading: state.isLoading,
    error: state.error,
    currentStep: state.currentStep
  };
};
